import React, { useContext, useEffect } from 'react';
import { PAGE_CONFIG } from './pageConfig';
// import { PAGE_CONFIG as NEW_PAGE_CONFIG } from './newPageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { useParams } from 'umi';
import './index.scss';
import { StudioContext } from '../context';

const Kol = () => {
  const { gameCode } = useParams();
  const { menuPermission } = useContext(StudioContext);

  useEffect(() => {
    // 设置全局样式
    const element = document.querySelector('.dbh-studio-context');
    if (element && menuPermission === true) {
      (element as HTMLElement).style.backgroundColor = '#ebecf1';
    }
    return () => {
      // 去掉全局样式
      if (element) {
        (element as HTMLElement).style.backgroundColor = '#fff';
      }
    };
  }, [menuPermission]);
  
  return (
    <CommonPageRender
      key={gameCode}
      reqParams={'/paidkol'}
      pageConfigInit={PAGE_CONFIG}
      frameType='game'
      api={PAGE_CONFIG_API}
    />
  );
};

export default Kol;
